import cn from 'classnames';
import React, { useMemo } from 'react';
import { injectIntl } from 'react-intl';
import * as PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import EmptyBlock from '../EmptyBlock';
import Loader from '../../../common/Loader';
import SurveysPopup from '../../../SurveysPopup';
import AppointmentCard from '../AppointmentCard';
import { VIRTUAL_VISIT_EVENTS } from '../../../../constants';
import AppointmentDetailsPopup from '../AppointmentDetailsPopup';
import { appointmentDetailsActions } from '../../../../redux/healthboard/appointment-details';
import {
  selectActiveAppointment,
  selectCurrentAppointmentSurveys,
  selectProviderActiveAppointment,
} from '../../../../redux/healthboard/selectors';

import styles from './styles.styl';

function AppointmentList({
  id,
  list,
  onClick,
  loading,
  isUpcoming,
  providerView,
  providerContext,
  paginationSending,
  intl: { formatMessage },
}) {
  const dispatch = useDispatch();

  const listSelector = providerView
    ? selectProviderActiveAppointment
    : selectActiveAppointment;

  const selected = useSelector(listSelector);

  const surveys = useSelector(selectCurrentAppointmentSurveys);

  const translationKey = useMemo(() => {
    return isUpcoming
      ? 'upcomingAppointmentsEmpty'
      : 'historyAppointmentsEmpty';
  }, [isUpcoming]);

  const emptyTextI18n = useMemo(() => {
    if (providerContext && providerView) {
      return 'forProvider';
    }

    if (providerContext) {
      return 'forProviderInContext';
    }

    return 'forPatient';
  }, [providerView, providerContext]);

  const handleAppointmentSelect = item => {
    dispatch(appointmentDetailsActions.setAppointmentId(item.id));
    onClick(item);
  };

  const handleStartVideoVisit = appointment => {
    dispatch(
      appointmentDetailsActions.changeStatus({
        event: VIRTUAL_VISIT_EVENTS.START_VISIT,
        appointment,
        id,
      }),
    );
  };

  const closeModal = () => {
    dispatch(appointmentDetailsActions.setAppointmentId(undefined));
  };

  return (
    <div
      className={cn('mt3', styles.root, { [styles.noMargin]: providerView })}
    >
      {loading && <Loader />}
      {paginationSending && (
        <div className={styles.paginationLoader}>
          <Loader />
        </div>
      )}
      {!loading &&
        list.map(item => {
          return (
            <AppointmentCard
              providerContext={providerContext}
              providerView={providerView}
              onStartVideoVisit={() => handleStartVideoVisit(item)}
              onClick={() => handleAppointmentSelect(item)}
              formatMessage={formatMessage}
              isUpcoming={isUpcoming}
              key={item.id}
              data={item}
            />
          );
        })}
      {!loading && !list.length && (
        <EmptyBlock
          icon="search-list"
          title={formatMessage({ id: `healthboard.title.${translationKey}` })}
          text={formatMessage({ id: `healthboard.empty.${emptyTextI18n}` })}
        />
      )}
      <AppointmentDetailsPopup
        onStartVideoVisit={handleStartVideoVisit}
        providerContext={providerContext}
        providerView={providerView}
        isUpcoming={isUpcoming}
        opened={!!selected}
        appointment={selected}
        onClose={closeModal}
        userId={id}
      />
      {!!surveys.length && <SurveysPopup surveys={surveys} />}
    </div>
  );
}

AppointmentList.propTypes = {
  list: PropTypes.array,
  providerContext: PropTypes.bool,
  providerView: PropTypes.bool,
  isUpcoming: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  intl: PropTypes.object,
  paginationSending: PropTypes.bool,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

AppointmentList.defaultProps = {
  list: [],
  onClick: () => {},
};

export default injectIntl(AppointmentList);



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/AppointmentList/index.jsx